/**
 * Client-side signals used to skip Sentry Session Replay for automation.
 * Bots rotate IPs; webdriver + headless UA tokens are a more stable filter.
 */
export interface BrowserAutomationSignals {
	webdriver?: boolean | null;
	userAgent?: string | null;
}

const HEADLESS_OR_AUTOMATION_UA =
	/headlesschrome|headless|playwright|puppeteer|phantomjs|selenium|jsdom|cypress|jepto-knowledgebase/i;

export function isAutomationOrHeadlessBrowser(
	signals: BrowserAutomationSignals
): boolean {
	if (signals.webdriver === true) {
		return true;
	}

	const userAgent = signals.userAgent ?? '';
	return HEADLESS_OR_AUTOMATION_UA.test(userAgent);
}

export function readBrowserAutomationSignals(
	nav: Pick<Navigator, 'userAgent'> & { webdriver?: boolean } = navigator
): BrowserAutomationSignals {
	return {
		webdriver: nav.webdriver,
		userAgent: nav.userAgent,
	};
}

export function shouldEnableSentryReplay(
	signals: BrowserAutomationSignals
): boolean {
	return !isAutomationOrHeadlessBrowser(signals);
}
